/* Sakura motion: scroll-bound scenes, no scroll interception or permanent loop. */
(() => {
  'use strict';
  const root = document.documentElement;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const desktop = matchMedia('(min-width:901px) and (min-height:650px)');
  const origin = document.querySelector('.evo-origin');
  const journey = document.querySelector('[data-journey]');
  const ritual = document.querySelector('.evo-ritual');
  const closing = document.querySelector('.motion-closing');
  const chapters = [...document.querySelectorAll('[data-journey-chapter]')];
  const active = new Set();
  const clamp = n => Math.max(0, Math.min(1, n));
  let frame = 0;
  let observer;
  let readCount = -1;
  const words = [];
  const quote = origin?.querySelector('.evo-founder');
  if (quote) {
    [...quote.childNodes].filter(n => n.nodeType === Node.TEXT_NODE).forEach(node => {
      const fragment = document.createDocumentFragment();
      node.textContent.split(/(\s+)/).forEach(word => {
        if (!word.trim()) { fragment.append(document.createTextNode(word)); return; }
        const span = document.createElement('span');
        span.className = 'motion-word';
        span.textContent = word;
        words.push(span);
        fragment.append(span);
      });
      node.replaceWith(fragment);
    });
  }
  origin?.querySelector('svg path')?.setAttribute('pathLength', '1');
  function render() {
    frame = 0;
    if (reduced.matches || document.hidden) return;
    const height = innerHeight;
    if (origin && active.has(origin)) {
      const rect = origin.getBoundingClientRect();
      const entry = clamp((height * .85 - rect.top) / (height * .62));
      const travel = (1 - entry) * (desktop.matches ? 52 : 12);
      origin.style.setProperty('--origin-left', `${-travel}px`);
      origin.style.setProperty('--origin-right', `${travel}px`);
      origin.style.setProperty('--route', 1 - entry);
      origin.style.setProperty('--manifesto-y', `${(1 - entry) * 30}px`);
      if (quote && words.length) {
        const q = quote.getBoundingClientRect();
        const count = Math.round(clamp((height * .88 - q.top) / (q.height + height * .2)) * words.length);
        if (count !== readCount) { words.forEach((word, i) => word.classList.toggle('is-read', i < count)); readCount = count; }
      }
    }
    if (journey && active.has(journey) && desktop.matches) {
      const box = journey.getBoundingClientRect();
      const stage = journey.querySelector('.journey-stage');
      const unit = stage.clientHeight;
      const t = -box.top / unit;
      journey.style.setProperty('--wipe-two', `${(1 - clamp((t - .48) / .48)) * 100}%`);
      journey.style.setProperty('--wipe-three', `${(1 - clamp((t - 1.48) / .48)) * 100}%`);
      journey.style.setProperty('--journey-progress', clamp(t / 2));
      const count = journey.querySelector('[data-journey-count]');
      const index = Math.min(2, Math.max(0, Math.floor(t + .45)));
      const label = `0${index + 1} / 03`;
      if (count.textContent !== label) count.textContent = label;
      chapters.forEach(chapter => {
        const rect = chapter.getBoundingClientRect();
        const distance = (rect.top + rect.height / 2 - height / 2) / height;
        chapter.style.setProperty('--chapter-opacity', Math.max(.65, 1 - Math.abs(distance) * .5));
        chapter.style.setProperty('--chapter-y', `${distance * -24}px`);
      });
    }
    if (ritual && active.has(ritual)) {
      const box = ritual.getBoundingClientRect();
      ritual.style.setProperty('--ritual-title-y', `${(1 - clamp((height - box.top) / (height * .7))) * 28}px`);
    }
  }
  function schedule() {
    if (!frame && !reduced.matches && !document.hidden) frame = requestAnimationFrame(render);
  }
  function sync() {
    observer?.disconnect();
    active.clear();
    cancelAnimationFrame(frame); frame = 0;
    root.classList.toggle('motion-on', !reduced.matches);
    root.classList.toggle('evo-motion', !reduced.matches);
    if (reduced.matches) {
      words.forEach(word => word.classList.add('is-read'));
      return;
    }
    readCount = -1;
    if (!('IntersectionObserver' in window)) { root.classList.remove('motion-on'); return; }
    observer = new IntersectionObserver(entries => {
      entries.forEach(({target, isIntersecting}) => {
        target.classList.toggle('is-motion-visible', isIntersecting);
        if (isIntersecting) {
          active.add(target);
          if (target.matches('[data-journey-chapter]')) target.classList.add('is-entered');
          if (target === closing) target.classList.add('is-blooming');
          if (target === ritual) target.classList.add('is-lit');
        } else active.delete(target);
      });
      schedule();
    }, {threshold:0, rootMargin:'0px 0px -12% 0px'});
    [origin, journey, ritual, closing, ...chapters].filter(Boolean).forEach(el => observer.observe(el));
    schedule();
  }
  addEventListener('scroll', schedule, {passive:true});
  addEventListener('resize', schedule, {passive:true});
  addEventListener('pageshow', schedule);
  document.addEventListener('visibilitychange', () => {
    root.classList.toggle('motion-paused', document.hidden);
    if (document.hidden) { cancelAnimationFrame(frame); frame = 0; } else schedule();
  });
  document.fonts?.ready.then(schedule);
  // Clipped lazy images can remain unloaded; request them just before this scene.
  if (journey && 'IntersectionObserver' in window) {
    const preload = new IntersectionObserver(entries => {
      if (!entries.some(entry => entry.isIntersecting)) return;
      journey.querySelectorAll('[data-journey-image]').forEach(image => {
        image.loading = 'eager';
        image.addEventListener('load', schedule, {once:true});
      });
      preload.disconnect();
    }, {rootMargin:'900px 0px'});
    preload.observe(journey);
  }
  reduced.addEventListener('change', sync);
  desktop.addEventListener('change', schedule);
  sync();
})();

// The hint fades after the first scroll, including with reduced motion enabled.
(() => {
  const hero = document.querySelector('.hero-story-cue');
  if (!hero) return;
  const update = () => document.documentElement.classList.toggle('hero-has-scrolled', scrollY > 40);
  addEventListener('scroll', update, {passive:true});
  addEventListener('pageshow', update);
  update();
})();
